<template>
  <Component
    :is="component"
    :asChild="asChild"
    :class="{ 'pointer-events-none': disabled }"
  >
    <slot />
  </Component>
</template>

<script setup>
import { computed } from "vue";
import { ResponsiveDialogClose } from "@/Components/Dialog";
import { SlideInLayerClose } from "@/Components/Sheet";

const props = defineProps({
  modal: {
    type: String,
    validator: (val) => ["dialog", "sheet"].includes(val),
    default: undefined,
  },
  asChild: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const componentMapping = {
  dialog: ResponsiveDialogClose,
  sheet: SlideInLayerClose,
};

const component = computed(() => componentMapping[props.modal] || "div");
</script>
